module.exports = __webpack_public_path__ + "static/media/phat-trien-nhan-cach-cho-tre.67f1e6f6.jpeg";